// extracted by mini-css-extract-plugin
export var htmlPreview = "_qr-2";
export var modal = "_qr-0";
export var sidebar = "_qr-1";